import React from 'react';
import { View } from '../elements';
import { HeroImage } from '../shared';
export const StickyHeader = ({ uri, isLoading = false, }) => {
    return (React.createElement(View, null,
        React.createElement(HeroImage, { uri: uri, isLoading: isLoading })));
};
//# sourceMappingURL=StickyHeader.js.map